import * as clsApi from "./classroomApi";

export const getClassroomDetails = async (
	classroomId,
	includeStudents,
	includeTeachers,
	includeSchedule,
	includeRules,
	type,
	sourceId,
	teacherId
) => {
	if (type === "CLASSROOM") {
		return await clsApi
			.Get(
				`classrooms/${encodeURIComponent(classroomId)}?
			includeStudents=${encodeURIComponent(includeStudents)}
			&includeTeachers=${encodeURIComponent(includeTeachers)}
			&includeSchedule=${encodeURIComponent(includeSchedule)}
			&includeRules=${encodeURIComponent(includeRules)}
			&sourceId=${encodeURIComponent(sourceId)}
			&teacherId=${encodeURIComponent(teacherId)}`
			)
			.then((data) => {
				return data.result;
			});
	} else {
		return await clsApi
			.Get(
				`groups/${encodeURIComponent(classroomId)}?
			includeMembers=${encodeURIComponent(includeStudents)}
			&includeOwners=${encodeURIComponent(includeTeachers)}
			&includeSchedule=${encodeURIComponent(includeSchedule)}
			&includeRules=${encodeURIComponent(includeRules)}
			&sourceId=${encodeURIComponent(sourceId)}
			&teacherId=${encodeURIComponent(teacherId)}`
			)
			.then((data) => {
				return data.result;
			});
	}
};

export const getSubgroups = async (groups) => {
	return await clsApi.Get(`subgroups?groups=${groups.join(",")}`);
};
